import { create } from 'zustand';
import { soundManager } from '../utils/soundManager';

interface AppState {
  // UI 狀態
  isMuted: boolean;
  currentTrack: string;

  // 捐款流程狀態
  selectedAmount: number | null;
  isMonthly: boolean;
  paymentMethod: string | null;

  // 動作
  toggleMute: () => void;
  playTrack: (track: 'hero' | 'story' | 'success') => void;
  pauseTrack: () => void;
  setSelectedAmount: (amount: number | null) => void;
  setIsMonthly: (isMonthly: boolean) => void;
  setPaymentMethod: (method: string | null) => void;
  resetDonationFlow: () => void;
}

export const useAppStore = create<AppState>((set) => ({
  isMuted: false,
  currentTrack: '',
  selectedAmount: null,
  isMonthly: false,
  paymentMethod: null,

  toggleMute: () => {
    const newMuted = soundManager.toggleMute();
    set({ isMuted: newMuted });
  },
  playTrack: (track) => {
    soundManager.playMusic(track);
    set({ currentTrack: track });
  },
  pauseTrack: () => {
    soundManager.pauseMusic();
    set({ currentTrack: '' });
  },
  setSelectedAmount: (amount) => set({ selectedAmount: amount }),
  setIsMonthly: (isMonthly) => set({ isMonthly }),
  setPaymentMethod: (method) => set({ paymentMethod: method }),
  resetDonationFlow: () => set({
    selectedAmount: null,
    isMonthly: false,
    paymentMethod: null,
  }),
}));
